import { render, staticRenderFns } from "./upload-ifc-document.vue?vue&type=template&id=0a8d1d17&scoped=true"
import script from "./upload-ifc-document.vue?vue&type=script&lang=js"
export * from "./upload-ifc-document.vue?vue&type=script&lang=js"
import style0 from "./upload-ifc-document.vue?vue&type=style&index=0&id=0a8d1d17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d1d17",
  null
  
)

export default component.exports